import React from 'react';
import { useParams } from 'react-router-dom';
import { 
  Download, 
  Printer, 
  Share2, 
  FileText, 
  Clock, 
  Users,
  AlertCircle 
} from 'lucide-react';
import { motion } from 'framer-motion';
import { sopData } from '../../data/sopData';
import BackButton from '../../../../components/BackButton';
import { exportManualToPDF } from '../../../../utils/pdfExport';

const ManualDetail = () => {
  const { id } = useParams();
  const manual = sopData.manuals.find(m => m.id === id);

  if (!manual) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <AlertCircle className="w-12 h-12 text-red-500 mb-4" />
        <h2 className="text-xl font-semibold text-gray-900">Manual Not Found</h2>
        <p className="text-gray-500 mt-2">The manual you're looking for doesn't exist.</p>
        <BackButton label="Back to Manuals" />
      </div>
    );
  }

  const handleExportPDF = () => {
    exportManualToPDF(manual);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="max-w-4xl mx-auto"
    >
      <div className="mb-8">
        <BackButton label="Back to Manuals" />
        
        <div className="flex justify-between items-start mt-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">{manual.title}</h1>
            <p className="text-gray-500 mt-2">Version {manual.version}</p>
          </div>
          <div className="flex gap-3">
            <button 
              onClick={handleExportPDF}
              className="p-2 hover:bg-gray-100 rounded-lg"
            >
              <Download className="w-5 h-5 text-gray-600" />
            </button>
            <button className="p-2 hover:bg-gray-100 rounded-lg">
              <Printer className="w-5 h-5 text-gray-600" />
            </button>
            <button className="p-2 hover:bg-gray-100 rounded-lg">
              <Share2 className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>
      </div>

      {/* Manual Content */}
      <div className="space-y-8">
        {manual.sections.map((section, index) => (
          <div key={index} className="bg-white rounded-xl shadow-sm p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              {section.title}
            </h2>
            <div className="prose max-w-none">
              {section.content}
            </div>
          </div>
        ))}
      </div>

      {/* Attachments */}
      {manual.attachments && manual.attachments.length > 0 && (
        <div className="mt-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Attachments</h2>
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="space-y-4">
              {manual.attachments.map((attachment, index) => (
                <div 
                  key={index}
                  className="flex items-center justify-between p-4 bg-gray-50 rounded-lg"
                >
                  <div className="flex items-center gap-3">
                    <FileText className="w-5 h-5 text-blue-600" />
                    <span className="text-gray-700">{attachment.name}</span>
                  </div>
                  <button className="text-blue-600 hover:text-blue-700">
                    <Download className="w-5 h-5" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default ManualDetail; 